export const USERDATA = "USERDATA"

export const NAVDATA = "NAVDATA"

export const LANG = "LANG"